var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBluePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 39,
    viewBox: "0 0 36 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0099 17.8202C22.877 17.8202 23.5799 17.1173 23.5799 16.2502C23.5799 15.3831 22.877 14.6802 22.0099 14.6802C21.1429 14.6802 20.4399 15.3831 20.4399 16.2502C20.4399 17.1173 21.1429 17.8202 22.0099 17.8202Z",
    fill: "#00C9B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5799 14.6201C15.1999 12.4301 15.2299 8.7901 14.2699 5.7701C13.7499 4.1201 12.49 2.4901 10.76 2.0201C8.48996 1.4101 6.89994 3.23011 5.32994 4.55011C3.22994 6.31011 1.49994 8.3001 1.64994 11.2101C1.88994 16.0201 5.23995 22.8301 9.05995 27.3801C9.11995 27.4501 9.17994 27.5201 9.23994 27.5901C13.0599 32.1501 19.1699 36.6401 23.8599 37.7201C26.5499 38.3401 28.97 37.0401 31 35.3801C33.03 33.7201 35.3299 31.8501 34.2699 28.9701C33.5299 26.9501 31.28 26.0601 29.39 25.4101C27.03 24.6001 24.4099 24.7001 22.4299 26.3501L21.45 27.2201C19.96 26.0501 18.13 24.7201 15.79 21.9301C13.37 19.0501 12.3999 17.0601 11.5299 15.4901L12.5899 14.6001L12.5799 14.6201Z",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0499 3.96021C27.8899 3.96021 34.2399 10.3102 34.2399 18.1502C34.2399 19.0702 34.1499 19.9602 33.9899 20.8302",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0499 9.63013C24.7499 9.63013 28.5699 13.4501 28.5699 18.1501C28.5699 18.4601 28.5499 18.7601 28.5199 19.0601",
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePhone);
export default __webpack_public_path__ + "static/media/blue-phone.e4e0fc4a01237bb958a14c29b4d41575.svg";
export { ForwardRef as ReactComponent };